var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGdpr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.241,
    height: 62.6,
    viewBox: "0 0 53.241 62.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.375 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.035,39.259,34.506,51.1a.978.978,0,0,0-.5.942l1.286,14.783A24.608,24.608,0,0,0,46.068,85.154l9.892,6.69a.976.976,0,0,0,1.1,0l9.892-6.689A24.617,24.617,0,0,0,77.725,66.823L79.011,52.04a.978.978,0,0,0-.5-.942L56.979,39.259A.975.975,0,0,0,56.035,39.259ZM77.006,52.505l-1.23,14.148a22.667,22.667,0,0,1-9.925,16.881l-9.344,6.319-9.344-6.32a22.667,22.667,0,0,1-9.925-16.88l-1.23-14.148,20.5-11.273Zm0,0",
    transform: "translate(-29.512 -34.348)",
    fill: "#f90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.109,14.223,27.467.122a.982.982,0,0,0-.944,0L.882,14.223a.977.977,0,0,0-.5.942L1.91,32.771a29.128,29.128,0,0,0,12.755,21.7l11.782,7.967a.981.981,0,0,0,1.1,0l11.782-7.968A29.128,29.128,0,0,0,52.081,32.771l1.531-17.607A.979.979,0,0,0,53.109,14.223ZM50.13,32.6a27.182,27.182,0,0,1-11.9,20.243L27,60.442l-11.233-7.6A27.183,27.183,0,0,1,3.861,32.6L2.384,15.631,27,2.1,51.607,15.631Zm0,0",
    transform: "translate(0 0)",
    fill: "#f90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.85,215.948v-3.914a.979.979,0,0,0-.979-.979H85.914v1.957h.979v1.957H83.957V209.1H88.85v-1.957H83.957A1.959,1.959,0,0,0,82,209.1v5.872a1.959,1.959,0,0,0,1.957,1.957h3.914A.979.979,0,0,0,88.85,215.948Zm0,0",
    transform: "translate(-71.64 -181.801)",
    fill: "#f90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.914,216.927a2.939,2.939,0,0,0,2.936-2.936v-3.914a2.94,2.94,0,0,0-2.936-2.936h-2.936a.979.979,0,0,0-.979.979v7.829a.979.979,0,0,0,.979.979Zm-1.957-7.829h1.957a.98.98,0,0,1,.979.979v3.914a.98.98,0,0,1-.979.979h-1.957Zm0,0",
    transform: "translate(-134.833 -181.801)",
    fill: "#f90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.914,213.991a2.939,2.939,0,0,0,2.936-2.936v-.979a2.94,2.94,0,0,0-2.936-2.936h-2.936a.979.979,0,0,0-.979.979v8.807h1.957v-2.936Zm0-4.893a.98.98,0,0,1,.979.979v.979a.98.98,0,0,1-.979.979h-1.957V209.1Zm0,0",
    transform: "translate(-198.026 -181.801)",
    fill: "#f90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.979,207.141a.979.979,0,0,0-.979.979v8.807h1.957v-2.936h2.149l.787,1.26v1.676h1.957v-1.957a.979.979,0,0,0-.149-.518l-.786-1.26a2.917,2.917,0,0,0,.936-2.136v-.979a2.94,2.94,0,0,0-2.936-2.936Zm3.914,2.936v.979a.98.98,0,0,1-.979.979h-1.957V209.1h1.957A.98.98,0,0,1,302.893,210.076Zm0,0",
    transform: "translate(-261.218 -181.801)",
    fill: "#f90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,146.076v1.957h1.957v-1.957a.98.98,0,0,1,.979-.979h21.529a.98.98,0,0,1,.979.979v1.957H133.4v-1.957a2.94,2.94,0,0,0-2.936-2.936H108.936A2.939,2.939,0,0,0,106,146.076Zm0,0",
    transform: "translate(-92.705 -125.63)",
    fill: "#f90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.444,313.1a.98.98,0,0,1-.979.979H108.936a.98.98,0,0,1-.979-.979v-1.957H106V313.1a2.939,2.939,0,0,0,2.936,2.936h21.529A2.939,2.939,0,0,0,133.4,313.1v-1.957h-1.957Zm0,0",
    transform: "translate(-92.705 -273.079)",
    fill: "#f90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,87.141h1.957v3.914H210Zm0,0",
    transform: "translate(-183.983 -76.48)",
    fill: "#f90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,375.141h1.957v5.872H210Zm0,0",
    transform: "translate(-183.983 -329.251)",
    fill: "#f90000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGdpr);
export default __webpack_public_path__ + "static/media/gdpr.2ae0371bd287180725a180b87c6718e5.svg";
export { ForwardRef as ReactComponent };